import { FC, PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

type Props = {
  disabled?: boolean;
};

const JourneyStepNumber: FC<PropsWithChildren<Props>> = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'disabled',
})<Props>(({ theme, disabled }) => ({
  fontSize: theme.fontSizes.sm,
  fontWeight: theme.typography.fontWeightMedium,
  lineHeight: '24px',
  color: theme.palette.common.white,
  width: '24px',
  height: '24px',
  textAlign: 'center',
  backgroundColor: theme.palette.grey[disabled ? 500 : 900],
  borderRadius: '50%',
}));

export default JourneyStepNumber;
